import {LanguageCountryConfig} from './language-country.config';

export const FRANCE_LANGUAGE_CONFIG: LanguageCountryConfig = {
  code: 'fr',
  locale: 'fr-FR',
  countryCode: 'FR',
  shortLabel: 'FR',
  labelKey: 'language.french',
  flag: '\uD83C\uDDEB\uD83C\uDDF7'
};
